import { useQuery } from '@tanstack/react-query'
import { PermissoesApi } from '@/services/api-routes'
import { permissoesKeys } from '@/http/queryKeys'
import { defaultOptions } from '@/http/default-query-options'

export const usePermissoesCatalogoQuery = (enabled = true) =>
  useQuery({
    queryKey: permissoesKeys.catalogo(),
    queryFn: async ({ signal }) => (await PermissoesApi.catalogo(signal)) ?? [],
    enabled,
    ...defaultOptions,
  })

export const usePermissoesUsuarioQuery = (usuarioBackofficeId: string | null) =>
  useQuery({
    queryKey: permissoesKeys.usuario(usuarioBackofficeId ?? ''),
    queryFn: async ({ signal }) =>
      (await PermissoesApi.obter(usuarioBackofficeId as string, signal)) ?? [],
    enabled: Boolean(usuarioBackofficeId),
    retry: false,
    ...defaultOptions,
  })
